import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import { useEffect, useRef, useState } from 'react';
import {CoachingCard} from '@/components';
import React, { Suspense } from 'react';


import { useLocation } from 'react-router';
import { services } from '@/data/services';
import { ScrollArrow } from '@/components/';
import { background,uccello, hero} from '@/assets';
import { useCookieStore } from '@/store/cookieStore';
import WhatsAppButton from '@/components/WhatsappButton';
import { BoxIcon } from 'lucide-react';

const TestimonialsCarousel = React.lazy(() => import('@/components/Home/TestimonialsCarousel'));
const StepsSection = React.lazy(() => import('@/components/Home/StepsSection'));


export default function Home() {


  const calendlyRef = useRef<HTMLDivElement>(null);
  const booksectionRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  const [showArrow, setShowArrow] = useState(true);
  

  const scrollToBooksection = () =>
    booksectionRef.current?.scrollIntoView({ behavior: 'smooth' });

  useEffect(() => {
    if (location.state?.scrollTo === 'calendly') {
      const el = document.getElementById('calendly');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight * 0.3) setShowArrow(false);
      else setShowArrow(true);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  return (
    <>
      {/* Freccia sempre visibile nella prima viewport */}
      {showArrow && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 40,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10,
          }}
        >
          <ScrollArrow onClick={scrollToBooksection} />
        </Box>
      )}

      {/* SFONDO */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: -2,
          
          pointerEvents: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          px: 4,

          backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 90%), url(${background})`,
          //backgroundColor: `red`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          opacity: 0.5
        }}

      >
      </Box>
      {/* PRIMA SEZIONE */}
      <Box
        >
        {/* HERO SECTION */}
        <Box  sx={{height:{xs: "20%",sm:"20%", md:"40%"}}}>
          <Grid container columnSpacing={4} alignItems="center" >
            <Grid item xs={12} md={8} sx={{ }}>
            <Box marginLeft={3}>
              <Typography
                sx={{
                  color: 'text.primary',
                  variant: 'h1',
                  fontWeight: 800,
                  fontSize: { xs: '2rem', sm: '2.5rem', md: '2.5rem' },
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                Risolvi i tuoi problemi
              </Typography>
              <Typography
                sx={{
                  variant: 'subtitle1',
                  fontSize: 20,
                  color: 'primary.main',
                  fontWeight: 'bold',
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                La Consulenza è completamente gratuita
              </Typography>
              <Grid
                container
                columnSpacing={2}
                alignItems="center"
                sx={{ mt: 4, display: { xs: 'none', md: 'flex' } }}
              >
                <Grid item xs={12} sm="auto">
                  <WhatsAppButton buttonText="Scrivimi su WhatsApp"   sx={{
                    fontSize: 20,          
                    textTransform: 'none', 
                    fontWeight: 'bold',
                    paddingBlock: '10px',  
                  }} />

                </Grid>
                <Grid item xs={12} sm>
                  <Typography
                    variant="body1"
                    color="text.primary"
                    sx={{
                      fontSize: '1.1rem',
                      fontWeight: 'bold',
                    }}
                  >
                    Semplifica la tua vita, <br />
                    Prendi decisioni con consapevolezza, <br />
                    Raggiungi i tuoi obiettivi.
                  </Typography>
                </Grid>
              </Grid>
              </Box>
            </Grid>

<Grid item md={4} sx={{ display: { xs: 'none', md: 'block' } }}>
  <Box
    component="img"
    src={hero}
    alt="Hero Illustration"
    sx={{
      marginTop: 2,
      width: '60%',           // si adatta alla colonna
      height: 'auto',          // mantiene proporzioni
      maxWidth: 350,           // limite massimo opzionale
      aspectRatio: '1 / 1',    // mantiene forma quadrata anche in resize
      borderRadius: '50%',
      objectFit: 'cover',
      boxShadow: 3,
      display: 'block',        // elimina spazi bianchi inline
    }}
  />
</Grid>
          </Grid>
        </Box> 

        {/* CARDS SECTION */}
        <Box
          sx={{  
            width: '100%',
            height: { xs: 'auto', md: '55%', lg: '55%'  },
            mt: { xs: 5  }
          
          }}
        >
          <Grid
            container
            spacing={{ xs: 2, sm: 3, md: 4 }}
            
            alignItems="stretch" // forza tutte le card alla stessa altezza
          >
            {services.map((card, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Box sx={{ height: '100%' }}> 
                  <CoachingCard {...card} />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

      </Box>

           <Container
        ref={booksectionRef}
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >

        <Suspense fallback={<div>Caricamento...</div>}>
          <StepsSection />
        </Suspense>



        <Box id="calendly" ref={calendlyRef} sx={{ display: 'flex', justifyContent: 'center', mt: 10,  }}>
          <WhatsAppButton buttonText="Scrivimi su WhatsApp"   sx={{
            fontSize: 20,          // testo grande
            textTransform: 'none', // evita maiuscole
            fontWeight: 'bold',
            paddingBlock: '10px',  // simile a size="large"
            paddingInline: '22px', // simile a size="large"
          }} />
        </Box>

        
        < Box sx={{ py:5, my:5 , px: { xs: 2, sm: 4 } }}>
        <Suspense fallback={<div>Caricamento...</div>}>
          <TestimonialsCarousel />
        </Suspense>
        </Box>
      </Container>


    </>
  );
}
